require('./product-categories-new-container.scss')

module.exports = {
  template: require('./product-categories-new-container.pug')()
  controller: require('./product-categories-new-container.ctrl')
}
